module.exports = __webpack_public_path__ + "img/bg-covid-image.30ab72cb.jpg";